import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogClose } from '@angular/material/dialog';
import { EmailNotificationSettings } from '../../../models/email-notification-settings';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-notifications-popup',
  templateUrl: './notifications-popup.component.html',
  styleUrl: './notifications-popup.component.scss',
  imports: [
    MatIcon,
    TranslateModule,
    MatButton,
    MatSlideToggle,
    FormsModule,
    MatDialogClose,
  ],
})
export class NotificationsPopupComponent {
  protected editedNotificationSettings: EmailNotificationSettings;

  constructor(@Inject(MAT_DIALOG_DATA) protected notificationSettings: EmailNotificationSettings) {
    this.editedNotificationSettings = { ...notificationSettings };
  }
}
